export default "__VITE_ASSET__1cfdc044__"